export default {
    contactsList: {
        actions: 'Actions',
        add: 'Nouveau',
        allTab: 'Tous',
        bulkAction: 'Actions de masse',
        delete: 'Supprimer',
        deleteModal: {
            header: 'Suppression de contacts',
            message: 'Voulez-vous vraiment supprimer les contacts sélectionnés?',
        },
        edit: 'Modifier',
        email: 'Courriel',
        firstName: 'Prénom',
        fullName: 'Nom complet',
        lastName: 'Nom',
        locale: 'Langue',
        noContacts: 'Aucun contact.',
        wouldYouLikeToAddOne: 'Voulez-vous en ajouter un?',
        pageTitle: 'Contacts',
        phone: 'Téléphone',
        search: 'Rechercher...',
        selectAll: 'Sélectionner tous les contacts',
        sendMassSms: 'Envoyer un SMS',
        consent: 'Adhésion',
        createPayment: 'Créer un paiement',
        successes: {
            deleted: 'Contact supprimé avec succès. | Contacts supprimés avec succès.',
        },
        errors: {
            deleting: 'Une erreur s\'est produite lors de la suppression du contact. | Une erreur s\'est produite lors de la suppression des contacts.',
        },
        subscribed: 'Abonné',
        subscribedTab: 'Abonné',
        unsubscribedTab: 'Désabonné',
        goToConversation: 'Aller à la conversation',
        createConversation: 'Créer une conversation',
        createAppointment: 'Créer un rendez-vous',
    },
    contactModal: {
        addTitle: 'Nouveau contact',
        editTitle: 'Modification contact',
        civility: 'Civilité',
        firstName: 'Prénom',
        lastName: 'Nom',
        locale: 'Langue',
        subscribedSms: 'Abonné aux SMS',
        subscribedEmail: 'Abonné aux courriels',
        maySendSms: 'Accepte de recevoir des SMS',
        mayNotSendSms: 'Refuse de recevoir des SMS',
        maySendEmail: 'Accepte de recevoir des courriels',
        mayNotSendEmail: 'Refuse de recevoir des courriels',
        onlyUserMayResubscribe: 'Seul le contact peut s\'abonner aux communications à nouveau.',
        notes: 'Notes',
        sms: 'SMS',
        email: 'Courriel',
        communicationPreference: 'Préférence de communication',
        phone: 'Téléphone',
        phoneNumbers: 'Numéros de téléphone',
        validate: 'Valider',
        addPhone: 'Ajouter un numéro',
        deletePhone: 'Supprimer le numéro',
        choose: 'Choisissez...',
        notifications: {
            success: {
                create: 'Le contact a été créé avec succès.',
                update: 'Le contact a été modifié avec succès.',
            },
            errors: {
                createContact: 'Une erreur s\'est produite lors de la création du contact.',
                updateContact: 'Une erreur s\'est produite lors de la modification du contact.',
                fetchContact: 'Une erreur s\'est produite lors de la mise à jour du contact.',
                createPhone: 'Une erreur s\'est produite lors de la création des numéros de téléphone.',
                editPhone: 'Une erreur s\'est produite lors de l\'enregistrement des numéros de téléphone.',
            },
        },
        validationTooltip: {
            userMustBeSaved: 'Le contact doit d’abord être enregistré',
            alreadyValidated: 'Déjà validé',
        },
    },
    phones: {
        allInvalid: 'Aucun cellulaire valide',
        invalid: 'Pas un cellulaire valide',
        notValidated: 'Le numéro n\'a pas encore été validé',
        none: 'Aucun téléphone',
    },
    email: {
        none: 'Aucun courriel',
    },
    sendMassSmsModal: {
        title: 'Envoi de message de masse',
        cancel: 'Annuler',
        sending: 'Envoi des messages en cours...',
    },
};
